import { Upload } from '@carbon/react/icons';
import classNames from 'classnames';
import { IconProps } from './types';

import style from './icons.module.scss';

const SupportingFile = ({ className }: IconProps) => {
  return (
    <div
      className={classNames(style.background, style.supportingFile, className)}
    >
      <Upload
        size={32}
        className={classNames(style.icon, style.supportingFile)}
      />
    </div>
  );
};

export default SupportingFile;
